import React, { useState, useEffect } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Parser } from "html-to-react";

const CustomICTooltip = ({ ic, name }) => {
  const [tooltipContent, setTooltipContent] = useState(null);
  const [icModified, setIcModified] = useState(null);
  const [nameModified, setNameModified] = useState(null);

  useEffect(() => {
    if (ic === "RMOD" || ic === "OSC" || ic === "Roadmap") {
      setIcModified("NIH Common Fund");
      setNameModified("NIH Common Fund");
    } else {
      setIcModified(ic);
      setNameModified(name);
    }
  }, [ic, name]);

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="tooltip-top">
          {tooltipContent ? Parser().parse(tooltipContent) : "Loading..."}
        </Tooltip>
      }
    >
      <span
        onMouseEnter={() => {
          setTooltipContent(nameModified);
        }}
        className="ic-tooltips"
        href=""
      >
        {icModified}
      </span>
    </OverlayTrigger>
  );
};

export default CustomICTooltip;
